/** Legacy fallback when the server doesn't report an effective limit. */
export const DEFAULT_DAILY_ORDER_LIMIT = 2;

/** Orders the user can still place today (never negative). */
export function remainingOrders(count: { totalOrder: number; limit?: number | null }): number {
  const limit = count.limit ?? DEFAULT_DAILY_ORDER_LIMIT;
  return Math.max(0, limit - (count.totalOrder || 0));
}
